<template>
	<div v-if="customer">
		<b-row class="justify-content-lg-center">
			<b-col>
				<b-card-title>{{ customer.name }}</b-card-title>
                <b-list-group>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('customer_label_street_address') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ customer.billingAddress.street ? customer.billingAddress.street : "-" }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('customer_label_zip_code') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ customer.billingAddress.zip ? customer.billingAddress.zip : "-" }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('customer_label_city') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ customer.billingAddress.city ? customer.billingAddress.city : "-" }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
			</b-col>
		</b-row>
		<b-row class="justify-content-lg-center">
			<b-col>
                <hr />
                <a :href="`/customer`" type="button" class="btn btn-secondary">{{ $t('customer_button_back_to_list') }}</a>
                <!--
                <a :href="`/customer/${customer.id}/edit`" type="button" class="btn btn-primary ml-2">{{ $t('customer_button_edit') }}</a>
                -->
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
    name: 'CustomerShow',
    props: ['customer'],
}
</script>